import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import * as Moment from "moment-timezone";
import { extendMoment } from "moment-range";
import { useRouter } from 'vue-router';
import { ReportsState } from '@/store/reports/types';

export default /*#__PURE__*/_defineComponent({
  __name: 'SearchByMonth',
  setup(__props) {

const momentRange = extendMoment(Moment);

const store = useStore();
const router = useRouter();

const moment = extendMoment(Moment);
const options = ref<{ value: string; label: string }[]>([]);

const reportsState = computed(() => store.state.reports as ReportsState);

/**
 * Set the options for the month selector, using moment-range.
 *
 * @link https://github.com/rotaready/moment-range
 */
const setOptions = () => {
  const startDate = new Date(2010, 0, 1); // January 1, 2010
  const endDate = moment().add(5, 'months').toDate(); // Adds 5 months to the current date
  const range = momentRange.range(startDate, endDate);
  options.value = Array.from(range.by("month"))
    .reverse()
    .map(date => ({
      value: date.format("YYYY-MM"),
      label: date.format("MMMM YYYY"),
    }));
};

const monthOption = computed(() => {
  return options.value.find(x => x.value === reportsState.value.month);
});

const resetCurrentPage = async () => {
  await store.dispatch('reports/resetCurrentPage');
};

const onSelect = async (selected: { value: string; label: string }) => {
  if (selected !== null) {
    router.push({
      path: "dereports",
      query: { month: selected.value },
    });
    await resetCurrentPage();
  }
};

onMounted(() => {
  setOptions();
});


return (_ctx: any,_cache: any) => {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_multiselect, {
      modelValue: monthOption.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((monthOption).value = $event)),
      options: options.value,
      "track-by": "value",
      label: "label",
      onSelect: onSelect,
      placeholder: "Month"
    }, null, 8, ["modelValue", "options"])
  ]))
}
}

})